<template>
  <!-- Componente de menú -->
  <MenuComponent modulo="reservas" :menuInferior="menuInferior"/>
  <!-- Sección principal -->
  <main class="items-center w-full px-4 py-4 mx-auto my-10 bg-white rounded-lg shadow-md sm:w-11/12">
    <!-- Componente de vista del enrutador -->
    <router-view v-slot="{ Component }">
      <Suspense timeout="0">
        <!-- Plantillas de contenido y de espera -->
        <template #default>
          <div class="container mx-auto">
            <!-- Componente dinámico -->
            <component :is="Component"></component>
          </div>
        </template>
        <template #fallback>
          <div class="container mx-auto">
            <!-- Componente de carga -->
            <LoadingComponent></LoadingComponent>
          </div>
        </template>
      </Suspense>
    </router-view>
  </main>
</template>

<script>
import MenuComponent from "@/layouts/MenuComponent";
import LoadingComponent from "@/layouts/LoadingComponent";
import {ref} from 'vue';

/**
 * Componente de menú para la sección de reservas.
 *
 * @vue/component
 * @module views/MenuReservas
 * @see {@link https://github.com/vuejs/jsdoc-vuejs|Documentación de jsdoc-vuejs}
 *
 * @example
 * // Para utilizar el componente, es necesario importarlo y registrar el nombre del componente en Vue.
 * import MenuReservas from "@/views/MenuReservas.vue";
 * export default {
 *   components: { MenuReservas }
 * }
 */
export default {
  /**
   * Nombre del componente.
   *
   * @type {string}
   */
  name: "MenuReservas",
  /**
   * Componentes de Vue utilizados en el componente.
   *
   * @type {Object}
   * @property {MenuComponent} MenuComponent - Componente de menú.
   * @property {LoadingComponent} LoadingComponent - Componente de carga.
   */
  components: {MenuComponent, LoadingComponent},
  /**
   * Datos del componente.
   *
   * @type {Object}
   * @property {Object[]} menuInferior - Opciones del menú inferior.
   * @property {string} menuInferior.alias - Alias del menú.
   * @property {string} menuInferior.name - Nombre del menú.
   * @property {boolean} menuInferior.current - Estado actual del menú.
   */

  setup() {
    /**
     * Carga el menú inferior con los elementos correspondientes según el rol del usuario.
     * @function cargarMenuInferior
     * @returns {Array} - Lista de objetos que representan los elementos del menú inferior.
     */

    const cargarMenuInferior = () => {
      const userStored = JSON.parse(localStorage.getItem("user"));
      const elementos = [];

      let idPadre = '';
      let newPermisos = userStored.permisosUsuariosEntities.concat(userStored.rol.permisosRolesEntities);

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso.menu
        if(dataMenu.name == 'MenuReservas'){
          idPadre = dataMenu.id
        }
      }

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso
    
        if(dataMenu.estado)
        {
          if(dataMenu.menu.menu_padre_id == idPadre && dataMenu.menu.estado)
          {
            const result = elementos.find(({ name }) => name === dataMenu.menu.name);
            if(!result){
              elementos.push({
                alias: dataMenu.menu.alias, 
                name:  dataMenu.menu.name,
                current: (dataMenu.menu.name == 'GestionarReservas') ? true : false   
              });
            }
          }
        }
      }

      // {alias: "Reservas Presupuestales", name: "ReservasPresupuestales", current: true},
      //   {alias: "Gestionar Reservas", name: "GestionarReservas", current: false},
      //   {alias: "Gestionar Cobro y Saldo", name: "GestionarCobroSaldo", current: false}
      
      return elementos;
    };

    const menuInferior = ref(cargarMenuInferior());
    return {
      /**
       * Lista de elementos del menú inferior.
       * @memberof MenuParametros
       * @type {Array}
       */
      menuInferior: menuInferior
    };
  },

};
</script>